import { useState } from "react";
import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/Marquee";
import { PromoSection } from "../components/home/PromoSection";
import { FeaturedServices } from "../components/home/FeaturedServices";
import { WhyYaya } from "../components/home/WhyYaya";
import { GalleryPreview } from "../components/home/GalleryPreview";
import { InstagramSection } from "../components/home/InstagramSection";
import { ServiceDrawer } from "../components/ServiceDrawer";
import { useTitle } from "../hooks/useTitle";

const marqueeItems = [
  "Feed-In Braids",
  "yaya just did that",
  "Knotless",
  "clean parts, always",
  "Stitch Braids",
  "book the look",
  "Cornrows",
  "hampton, virginia",
];

export default function HomePage() {
  useTitle("HairByYaya | Braids & Protective Styles in Hampton, VA");
  const [selected, setSelected] = useState(null);

  return (
    <>
      <Hero />
      <Marquee items={marqueeItems} />
      <PromoSection />
      <FeaturedServices onSelect={setSelected} />
      <WhyYaya />
      <GalleryPreview />
      <InstagramSection />
      <ServiceDrawer service={selected} onClose={() => setSelected(null)} />
    </>
  );
}

